// extracted by mini-css-extract-plugin
module.exports = {"picture":"picture___2WLBl","content":"content___2nzd-","title":"title___fALD2","featuredAuthor":"featuredAuthor___3BgBd","eyebrow":"eyebrow___2FYg6","info":"info___3kaZG"};